var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.528 119.056C92.296 119.056 119.056 92.297 119.056 59.528C119.056 26.731 92.297 0 59.528 0C26.731 0 0 26.731 0 59.528C0 92.297 26.731 119.056 59.528 119.056Z",
    fill: "#4C4E53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4062 48.4207V42C39.4062 30.3502 48.8502 20.9062 60.5 20.9062C72.1498 20.9062 81.5938 30.3502 81.5938 42V48.4207C85.0774 48.6808 87.3459 49.3377 89.0041 50.9959C91.75 53.7417 91.75 58.1612 91.75 67C91.75 75.8388 91.75 80.2583 89.0041 83.0041C86.2583 85.75 81.8388 85.75 73 85.75H48C39.1612 85.75 34.7417 85.75 31.9959 83.0041C29.25 80.2583 29.25 75.8388 29.25 67C29.25 58.1612 29.25 53.7417 31.9959 50.9959C33.6541 49.3377 35.9226 48.6808 39.4062 48.4207ZM44.0938 42C44.0938 32.9391 51.4391 25.5938 60.5 25.5938C69.5609 25.5938 76.9062 32.9391 76.9062 42V48.2612C75.7093 48.25 74.411 48.25 73 48.25H48C46.589 48.25 45.2907 48.25 44.0938 48.2612V42ZM48 70.125C49.7259 70.125 51.125 68.7259 51.125 67C51.125 65.2741 49.7259 63.875 48 63.875C46.2741 63.875 44.875 65.2741 44.875 67C44.875 68.7259 46.2741 70.125 48 70.125ZM60.5 70.125C62.2259 70.125 63.625 68.7259 63.625 67C63.625 65.2741 62.2259 63.875 60.5 63.875C58.7741 63.875 57.375 65.2741 57.375 67C57.375 68.7259 58.7741 70.125 60.5 70.125ZM76.125 67C76.125 68.7259 74.7259 70.125 73 70.125C71.2741 70.125 69.875 68.7259 69.875 67C69.875 65.2741 71.2741 63.875 73 63.875C74.7259 63.875 76.125 65.2741 76.125 67Z",
    fill: "#FFC949",
    stroke: "#0B0B0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.185e2f57ff2ab2e4fc14d0992b40ba24.svg";
export { ForwardRef as ReactComponent };